let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("awMlP")).then(() => parcelRequire('WO5HT'));